module.exports = __webpack_public_path__ + "img/23320f8.jpg";